<template>
  <div class="layout">
    <navigation></navigation>
    <div class="fixed-forgrid">
      <slot />
    </div>
    <qaz-footer></qaz-footer>
  </div>
</template>

<script>
import Navigation from "@/components/navigation/HomeNavigation.vue";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      loading: true
    };
  },

  components: {
    navigation: Navigation,
    "qaz-footer": Footer
  }
};
</script>
